import { Component, ElementRef, OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import {OroService} from './oroservice';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(  public translate: TranslateService,
                private router: Router,
                public oroservice: OroService,
                public cookieservice: CookieService,
                private elementRef: ElementRef) {

      const browserLang = translate.getBrowserLang();
      translate.use(browserLang.match(/de|fr/) ? browserLang : 'de'); 
      console.log(browserLang);
      this.cookieservice.set('lang', browserLang);
  }

  ngOnInit() {
    this.elementRef.nativeElement.removeAttribute("ng-version");
    window.addEventListener('wheel', (event) => {
        const target = event.target as HTMLInputElement;
        if (target && target.tagName.toLowerCase() === 'input' && target.getAttribute('type') === 'number') {
          event.preventDefault();
        }
      }, { passive: false });

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
